export default __webpack_public_path__ + "static/media/2 a.36a88b8f.png";